import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import AppContext from "../../container/context";
import { formatDateTime, mergeParams } from "../../helpers/helpers";
import { CircularProgress } from "@mui/material";
import ActionTable from "../../components/table/ActionTable";

export default function Agenda({ history, location }) {
  const [filtros, setFiltros] = useState(
    mergeParams({ escolaId: 0 }, location)
  );
  const [comboEscolas, setComboEscolas] = useState([]);
  const [agenda, setAgenda] = useState([]);
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [mode, setMode] = useState("list");
  const [agendaItem, setAgendaItem] = useState({});

  useEffect(() => {
    if (filtros.escolaId > 0) {
      carregarAgenda();
    }
    carregarComboEscolas();
  }, []);

  const carregarComboEscolas = () => {
    api.get("escolas/listar", { ativas: true }).then((res) => {
      setComboEscolas(res);
    });
  };

  const carregarAgenda = (filtrosEnviar = filtros) => {
    setCarregando(true);
    setFiltros(filtrosEnviar);

    api.get("agenda/carregar", filtrosEnviar).then((res) => {
      res.forEach((a) => {
        a.inicioTeachersLista = a.inicioTeachers
          ? formatDateTime(a.inicioTeachers.split("T")[0], "D/M/Y")
          : "";
        a.inicioFamilyLista = a.inicioFamily
          ? formatDateTime(a.inicioFamily.split("T")[0], "D/M/Y")
          : "";
      });

      setCarregando(false);
      setAgenda(res);
    });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      escolaId: {
        label: "Escola",
        type: "select",
        value: filtros.escolaId,
        array: {
          data: comboEscolas,
          value: "id",
          desc: "nomeFantasia",
        },

        emptyItem: true,
        emptyItemText: "(Selecione)",
      },
    },
    submit: {
      action: carregarAgenda,
      auto: true,
    },

    urlParams: true,
    history,
    location,
  };

  const tRegistros = {
    title: "Conteúdo Programado",
    columns: [
      {
        name: "cicloNome",
        label: "Ciclo",
      },
      {
        name: "unidadeSequencia",
        label: "Sequência",
      },
      {
        name: "unidadeNumero",
        label: "Número",
      },
      {
        name: "unidadeTitulo",
        label: "Unidade",
      },
      {
        name: "unidadeDuracao",
        label: "Duração",
      },
      {
        name: "inicioTeachersLista",
        label: "Início Teachers",
        emptyText: "(Não cadastrado)",
      },
      {
        name: "inicioFamilyLista",
        label: "Início Family",
        emptyText: "(Não cadastrado)",
      },
    ],

    onLineClick: (agendaItem) => {
      setAgendaItem(agendaItem);
      setMode("update");
    },

    array: agenda,
  };

  const salvar = (params) => {
    api
      .post("agenda/salvar", {
        escolaId: filtros.escolaId,
        unidadeId: agendaItem.unidadeId,
        inicioTeachers: params.inicioTeachers,
        inicioFamily: params.inicioFamily,
      })
      .then((res) => {
        notification("success", "Agenda alterada!");
        setAgendaItem({});
        setMode("list");
        carregarAgenda();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Escola inválida");
          case 2:
            return notification("error", "Unidade inválida");
          case 3:
            return notification(
              "error",
              "Data de início Perto Teachers inválida."
            );
          case 4:
            return notification(
              "error",
              "Data de início Perto Family inválida."
            );
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fDados = {
    title: "Dados",
    form: {
      cicloNome: {
        label: "Ciclo",
        type: "component",
        space: 3,
        value: (
          <>
            <h4>Ciclo</h4>
            <p>{agendaItem.cicloNome}</p>
          </>
        ),
      },

      unidadeTitulo: {
        label: "Unidade",
        type: "component",
        space: 3,
        value: (
          <>
            <h4>Unidade</h4>
            <p>{agendaItem.unidadeTitulo}</p>
          </>
        ),
      },

      unidadeNumero: {
        label: "Número da unidade",
        type: "component",
        space: 3,
        value: (
          <>
            <h4>Número da unidade</h4>
            <p>{agendaItem.unidadeNumero}</p>
          </>
        ),
      },

      duracao: {
        label: "Número da unidade",
        type: "component",
        space: 3,
        value: (
          <>
            <h4>Duração (dias)</h4>
            <p>{agendaItem.unidadeDuracao}</p>
          </>
        ),
      },

      inicioTeachers: {
        label: "Início Teachers",
        type: "date",
        value: agendaItem.inicioTeachers
          ? agendaItem.inicioTeachers
          : undefined, //agendaItem.previsaoInicio,
        space: 6,
      },
      inicioFamily: {
        label: "Início Family",
        type: "date",
        value: agendaItem.inicioFamily ? agendaItem.inicioFamily : undefined, //agendaItem.previsaoInicio,
        space: 6,
      },
    },
    submit: {
      label: "Salvar",
      action: salvar,
    },
    close: {
      label: "Fechar",
      action: () => {
        setAgendaItem({});
        setMode("list");
      },
    },
  };

  return (
    <div>
      {mode === "list" ? (
        <>
          <Form formData={fFiltros} />

          {carregando ? (
            <CircularProgress />
          ) : (
            <>{agenda.length > 0 && <ActionTable structure={tRegistros} />}</>
          )}
        </>
      ) : (
        <Form formData={fDados} />
      )}
    </div>
  );
}
